import { Injectable } from '@angular/core';
import { InspectionTireDto, PostingDataResponseModel, SetTiresCertifiedByUser, TireAbbreviations } from 'remarketing-angular-library';
import { Store } from '@ngxs/store';

@Injectable({
  providedIn: 'root'
})
export class TireValidationHelperService {

  constructor(
    private readonly store: Store) {
  }

  handleTireValidationOnExistingPostingLoad(postingData: PostingDataResponseModel): boolean {
    const tires = this.getTiresFromPostingData(postingData);
    if(tires) {
      if(tires.length > 0) {
        // If tires exist, user certification will be false, we must also check tires data validity
        return this.isAllFourRequiredTiresDataPresent(postingData);
      } else {
        // If no tires in data, certification checkbox is checked on load
        return true;
      }
    } else {
      // If tires on load are undefined, the EditPosting state sets them as an empty array and checkbox is checked
      return true;
    }
  }

  setTiresCertifiedByUserOnExistingPostingLoad(postingData: PostingDataResponseModel): void {
    const tires = this.getTiresFromPostingData(postingData);
    if(tires) {
      if(tires.length > 0) {
        this.store.dispatch(new SetTiresCertifiedByUser(false));
      } else {
        this.store.dispatch(new SetTiresCertifiedByUser(true));
      }
    } else {
      this.store.dispatch(new SetTiresCertifiedByUser(true));
    }
  }

  isAllFourRequiredTiresDataPresent(postingData: PostingDataResponseModel): boolean {
    const tiresInStore = [];
    const tires = this.getTiresFromPostingData(postingData);
    if(tires?.length > 0) {
      tires.forEach(tire => tiresInStore.push(tire.location));
    }

    return tiresInStore.includes(TireAbbreviations.FRONT_RIGHT) && tiresInStore.includes(TireAbbreviations.FRONT_LEFT)
            && tiresInStore.includes(TireAbbreviations.REAR_RIGHT) && tiresInStore.includes(TireAbbreviations.REAR_LEFT)
            && this.isMinimumFieldsForTires(tires);
  }

  isMinimumFieldsForTires(tires: InspectionTireDto[]): boolean {
    const results = [];
    tires.forEach(tire => {
      if(tire.location !== TireAbbreviations.SPARE) {
        results.push(this.minimumTireDataPresent(tire));
      }
    });
    return !results.includes(false);
  }

  minimumTireDataPresent(tire: InspectionTireDto): boolean {
    return this.isNotNullOrUndefined(tire.location) && this.isNotNullOrUndefined(tire.manufacturer)
              && this.isNotNullOrUndefined(tire.size) && this.isNotNullOrUndefined(tire.tread);
  }

  getTiresFromPostingData(postingData: PostingDataResponseModel) {
    return postingData?.inventoryItem?.inspectionReport?.inspectionData?.vehicle?.tires;
  }

  isNotNullOrUndefined(value): boolean {
    return value !== null && value !== undefined;
  }

}
